export interface ClaimFile {
  dossier_id: string;
  file_id: string;
  file_name: string;
  file_type: 'DOC' | 'ACTIVITY';
  file_scope?: string;
  contents_type: string;
  mime_type?: string;
  updated_at: string;
  total_pages: number;
  received_at: string;
  file_size?: number;
  ingest_status: string;
  ingest_error?: string;
  raw_content_path?: { s3_bucket: string; s3_key: string };
  tags?: string[];
  title?: string | null;
  toc: { data_version: string; markdown: string };
  user_note: string;
  created_at?: string;
  escalation_id?: string | null;
  // Set on notes that were created against a task; task_title is the linked
  // task's name (resolved by the backend when listing files).
  task_id?: string | null;
  task_title?: string | null;
  data?: {
    description?: string;
    [key: string]: unknown;
  };
}

export type SelfServiceClaimFile = Pick<
  ClaimFile,
  | 'file_name'
  | 'received_at'
  | 'file_size'
  | 'raw_content_path'
  | 'tags'
  | 'file_scope'
  | 'title'
> & {
  data: { auto_tag: boolean };
};

export const TEXT_MIME_TYPES = [
  'text/html',
  'text/rtf',
  'application/rtf',
  'text/plain',
];

// TODO: DocumentCitations format tbd
export interface DocumentCitations {
  [documentId: string]: string;
}

export interface GetPresignedUploadResponse {
  url: string;
  contentType: string;
  metadata: Record<string, string>;
  file: File;
}
